import update from 'immutability-helper';
import ActionTypes from 'constants/ActionTypes';

const initialState = {
    fetching: false,
    error: {
        status: null,
        text: null,
    },
    data: {},
};

const contentTypesReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.DATA_CONTENT_TYPES_FETCHING: {
            return update(state, {
                fetching: { $set: true },
            });
        }
        case ActionTypes.DATA_CONTENT_TYPES_RECEIVED: {
            return update(state, {
                fetching: { $set: false },
                data: { $merge: action.payload },
                error: { $set: initialState.error },
            });
        }
        case ActionTypes.DATA_SINGLE_CONTENT_TYPES_RECEIVED: {
            return update(state, {
                data: { $merge: action.payload },
                error: { $set: initialState.error },
            });
        }
        case ActionTypes.DATA_CONTENT_TYPES_ERROR: {
            return update(state, {
                data: { $set: initialState.data },
                fetching: { $set: false },
                error: {
                    status: { $set: action.payload.status },
                    text: { $set: action.payload.text },
                },
            });
        }
        default: {
            return state;
        }
    }
};

export default contentTypesReducer;
